<template>
 <transition enter-active-class="fadeIn" leave-active-class="fadeOut">
  <aside class="animated" :class="[showAside ? 'showAside' : '']">
   <button class="close" @click="$emit('showAside',false)"><i class="fas fa-times-circle"></i></button>
   <ul>
    <li><router-link to="/"><i class="icon fas fa-star"></i><span class="text">About Me</span></router-link></li>
    <li><router-link to="/contact"><i class="icon fas fa-envelope"></i><span class="text">Contact</span></router-link></li>
    <li><router-link to="/projects"><i class="icon fas fa-hammer"></i><span class="text">Projects</span></router-link></li>
    <li><router-link to="/journal"><i class="icon fas fa-book"></i><span class="text">Journal</span></router-link></li>
   </ul>
  </aside>
 </transition>
</template>
<script>
 export default {
  props:['showAside'],
  mounted(){
   //eslint-disable-next-line
   this.$router.afterEach( (to,from)=>{ this.$emit('showAside',false); } );
  }
 }
</script>
<style lang="scss" scoped>
aside{
 padding:10px;
}
button.close{ display:none; }
//this is triggered by the menu button that is only visible on mobile
.showAside{
 display:flex !important;
 align-items: flex-end;
 position: fixed;
 overflow:scroll;
 flex-direction: column;
 top: 0;
 padding: 0;
 left: 0;
 bottom: 0;
 background-color: rgba(0,0,0,0.9);
 button.close{
  display: block;
  margin:0 0 auto 0;
  padding:10px;
  font-size: 50px;
  color:#FFF;
  -webkit-appearance: none;
  border: none;
  background: none;
 }
 ul{
  width: calc(100vw - 2px);
  height: calc(100vh - 70px);
 }
}
ul{
 list-style: none;
 margin: 0;
 padding: 0;
 height: 100%;
 background-image: linear-gradient(180deg, rgba(136,136,136,0.10) 0%, rgba(136,136,136,0.50) 100%);
 border: 1px solid #979797;
}
li{
 border:1px solid #FFF;
}
a:hover, a.router-link-exact-active{
 background:linear-gradient(90deg, #1A1962 0%, #000000 100%);
}
a{
 display:flex;
 justify-content: space-evenly;
 align-items: center;
 text-decoration: none;
 color: #FFF;
 font-size: 1.5rem;
 padding: 10px;
 transition:all 0.3s ease-in-out;
}
.icon{
 width:100px;
 text-align: center;
 font-size:30px;
}
.text{
 width: 100%;
 text-align:left;
}
//mobile
@media screen and (max-width:750px){
 aside{ display:none; }
}
</style>